import { render, staticRenderFns } from "./mo-date-year-wrapper.html?vue&type=template&id=8d9a599e&external"
import script from "./mo-date-year-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-date-year-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-date-year-wrapper.vue?vue&type=style&index=0&id=8d9a599e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports